import { User, UserData } from '../Types';
import requestClient from '../components/Utility/RequestClient';
import { StoreEnvironment } from '../Types/StoreTypes';
import { store } from '../store';

const resolveDemo = () => (store.getState().environment as StoreEnvironment).demoInstance;

export const userService = {
    saveUser: async (identifier: string, data: any): Promise<any> => {
        return requestClient.post<User>('/users/update/' + identifier, data);
    },

    getUser: async (identifier: string): Promise<{ data: User }> => {
        return requestClient.get<User>(`${resolveDemo() ? '/demo' : ''}/users/get/${identifier}`);
    },

    getUsers: async (): Promise<{ data: UserData[] }> => {
        return requestClient.get<UserData[]>(`${resolveDemo() ? '/demo' : ''}/users/get`);
    },

    getUsersByPage: async (
        page: number,
        itemsPerPage: number,
        optionalParams?: Record<string, string>,
        query?: string | null,
    ): Promise<{ data: { data: User[]; total: number } }> => {
        const response = await requestClient.get<UserData>(`${resolveDemo() ? '/demo' : ''}/users/get`, {
            params: {
                page,
                itemsPerPage,
                query,
            },
        });
        return {
            data: {
                data: response.data.data,
                total: response.data.total,
            },
        };
    },

    getUsersByGroup: async (
        page: number,
        itemsPerPage: number,
        groupIdentifier: string,
        query?: string|null
    ): Promise<{ data: { data: User[]; total: number } }> => {
        const response = await requestClient.get<{ data: User[]; total: number }>(
            `${
                resolveDemo() ? '/demo' : ''
            }/users/getusersbygroup/${groupIdentifier}`,{
                params: {
                    page,
                    itemsPerPage,
                    query,
                },
            });
        return {
            data: response.data,
        };
    },

    logout: async (): Promise<any> => {
        return requestClient.post<void>('/logout');
    },

    syncUsers: async (): Promise<{ data: { success: boolean; message: string } }> => {
        return requestClient.post<{ success: boolean; message: string }>(`${resolveDemo() ? '/demo' : ''}/users/sync`);
    },

    getSyncStatus: async (): Promise<{
        data: {
            isRunning: boolean;
            startDate: string | null;
            endDate: string | null;
            duration: number | null;
            prev?: {
                startDate: string;
                endDate: string;
                duration: number;
            };
        };
    }> => {
        return requestClient.get(`${resolveDemo() ? '/demo' : ''}/users/sync/status`);
    },
};
